module.exports = __webpack_public_path__ + "f64038fc22194360057cdb4b4a9edfcb.svg";